import { formsActions } from "@common/redux/forms/actions";
import {
  IInfographicsDashboardDataServer,
  IFormServer,
  IFormsMap,
  IFormsState,
  IInfographicGridData,
  IInfographicsDashboardDataClient,
  IDashboardDataMap,
  IActiveInfographicAnalytics,
  ISubmissionCount,
  ICustomPermission,
} from "@common/redux/forms/interface";
import { formInitialStateServer } from "@common/redux/formBuilder/utils";
import {
  IAdvancedRulesClient,
  IAdvancedRulesServer,
} from "../formBuilder/interface";
import { customPermissionInitialState } from "./utils";
import { IWorkflowServer } from "../formSubmission/interface";
export const formsDataInitialState = {
  formIds: [],
  totalForms: 0,
  totalPages: 0,
  pageNumber: 0,
};
export const infographicMapInitialState = {
  activeFormInfographic: {
    rowCount: 0,
    columnCount: 0,
  },
  activeInfographicAnalytics: {},
  activeInfographicDataByQuery: {},
};
export const initialState: IFormsState = {
  formsData: formsDataInitialState,
  formsMap: {},
  rulesMap: {},
  workflowMap: {},
  infographicMap: infographicMapInitialState,
  submissionCountMap: {},
  dashboardDataMap: {},
  customPermission: customPermissionInitialState,
  loaders: {
    addNewForm: false,
    updateForm: false,
    deleteForm: false,
    fetchForm: false,
    fetchFormByIds: false,
    duplicateForm: false,
    createFormRules: false,
    fetchFormRules: false,
    updateFormRules: false,
    deleteFormRules: false,
    fetchInfographicsDashBoardDataById: false,
    updateInfographicsDashBoardDataById: false,
    addInfographicsDashBoardDataById: false,
    deleteInfographicsDashBoardDataByFormId: false,
    addFormAnalytics: false,
    getFormAnalytics: false,
    getInfographicDataByQuery: false,
    getSubmissionCount: false,
    fetchPermissionById: false,
    fetchWorkFlow: false,
  },
  errors: {
    addNewForm: "",
    updateForm: "",
    deleteForm: "",
    fetchForm: "",
    fetchFormByIds: "",
    duplicateForm: "",
    createFormRules: "",
    fetchFormRules: "",
    updateFormRules: "",
    deleteFormRules: "",
    fetchInfographicsDashBoardDataById: "",
    updateInfographicsDashBoardDataById: "",
    addInfographicsDashBoardDataById: "",
    deleteInfographicsDashBoardDataByFormId: "",
    addFormAnalytics: "",
    getFormAnalytics: "",
    getInfographicDataByQuery: "",
    getSubmissionCount: "",
    fetchPermissionById: "",
    fetchWorkFlow: "",
  },
};

export const formsReducer = (
  state: IFormsState = initialState,
  action: { type: string; payload: any }
) => {
  switch (action.type) {
    case formsActions.FETCH_FORMS: {
      const formsPayload = action.payload;
      let formIds = state?.formsData?.formIds || [];
      if (formsPayload?.pageNumber == 0) {
        formIds = [];
      }
      return {
        ...state,
        loaders: {
          ...state.loaders,
          fetchForm: true,
        },
        formsData: {
          ...state?.formsData,
          formIds,
        },
      };
    }
    case formsActions.FETCH_FORMS_SUCCESS: {
      const forms: IFormServer[] = action?.payload?.content;
      const { pageNumber, pageSize, totalElements, totalPages } =
        action.payload;
      const formIds: string[] =
        pageNumber == 0 ? [] : state?.formsData?.formIds;
      const updatedFormsMap: IFormsMap =
        pageNumber == 0 ? {} : { ...state.formsMap };
      forms.forEach((formData: IFormServer) => {
        const formId = formData?.id;
        if (!formIds.includes(formId)) {
          formIds.push(formId);
        }
        updatedFormsMap[formId] = formData;
      });

      return {
        ...state,
        formsData: {
          ...state?.formsData,
          formIds,
          totalForms: totalElements,
          totalPages: totalPages,
          pageNumber: pageNumber,
        },
        formsMap: updatedFormsMap,
        loaders: {
          ...state.loaders,
          fetchForm: false,
        },
      };
    }
    case formsActions.REMOVE_FORM_BY_ID: {
      const formId = action.payload.formId;
      const updatedFormsMap = { ...state.formsMap };
      delete updatedFormsMap[formId];
      const updatedformIds = state.formsData.formIds.filter(
        (data) => data != formId
      );

      return {
        ...state,
        formsData: {
          ...state.formsData,
          formIds: updatedformIds,
        },
        formsMap: updatedFormsMap,
        loaders: {
          ...state.loaders,
          fetchForm: false,
        },
        errors: {
          ...state.errors,
        },
      };
    }
    case formsActions.FETCH_FORMS_FAILED: {
      const error = action.payload.error;
      const pageNumber = action.payload.pageNumber;
      let updatedFormsMap = state.formsMap;
      let updatedformIds = state.formsData.formIds;
      if (pageNumber == 0) {
        updatedFormsMap = {};
        updatedformIds = [];
      }
      return {
        ...state,
        formData: {
          ...state.formsData,
          formIds: updatedformIds,
        },
        formsMap: updatedFormsMap,
        loaders: {
          ...state.loaders,
          fetchForm: false,
        },
        errors: {
          ...state.errors,
          fetchForm: error,
        },
      };
    }

    case formsActions.FETCH_FORM_RULES: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          fetchFormRules: true,
        },
      };
    }

    case formsActions.FETCH_FORM_RULES_SUCCESS: {
      const formRules: IAdvancedRulesServer = action?.payload;
      const { formId } = formRules;
      const updateFormRules = {
        ...state.rulesMap,
        [formId]: formRules,
      };

      return {
        ...state,
        rulesMap: updateFormRules,
        loaders: {
          ...state.loaders,
          fetchFormRules: false,
        },
      };
    }

    case formsActions.FETCH_FORM_RULES_FAILURE: {
      const error = action.payload.error;
      return {
        ...state,
        loaders: {
          ...state.loaders,
          fetchFormRules: false,
        },
        errors: {
          ...state.errors,
          fetchFormRules: error,
        },
      };
    }

    case formsActions.FETCH_FORM_BY_IDS: {
      const isCurrentForm = action?.payload?.isCurrentForm ?? false;
      return {
        ...state,

        loaders: {
          ...state.loaders,
          fetchFormByIds: isCurrentForm,
        },
      };
    }

    case formsActions.FETCH_FORM_BY_IDS_SUCCESS: {
      const forms: IFormServer[] = action.payload;
      const formIds: string[] = [...state?.formsData?.formIds];
      const formsMap: IFormsMap = {};
      forms.forEach((formData: IFormServer) => {
        if (!formIds.includes(formData.id)) {
          formIds.push(formData.id);
        }
        formsMap[formData.id] = formData;
      });

      const updatedFormsMap: IFormsMap = { ...state.formsMap, ...formsMap };

      return {
        ...state,
        formsData: {
          ...state?.formsData,
          formIds,
        },
        formsMap: updatedFormsMap,
        loaders: {
          ...state.loaders,
          fetchFormByIds: false,
        },
      };
    }
    case formsActions.FETCH_FORM_BY_IDS_FAILED: {
      const error = action.payload.error;

      return {
        ...state,
        loaders: {
          ...state.loaders,
          fetchFormByIds: false,
        },
        errors: {
          ...state.errors,
          fetchFormByIds: error,
        },
      };
    }

    case formsActions.ADD_NEW_FORM: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          addNewForm: true,
        },
      };
    }
    case formsActions.ADD_NEW_FORM_SUCCESS: {
      const formData: IFormServer = action.payload.formData;
      const formId: string = formData?.id;
      const updatedFormIds: string[] = [formId, ...state?.formsData?.formIds];
      const updatedFormsMap: IFormsMap = { ...state.formsMap };

      const newForm: IFormServer = { ...(formData || formInitialStateServer) };
      newForm.localId = formId;
      updatedFormsMap[formId] = newForm;
      const { totalForms } = state?.formsData;
      return {
        ...state,
        formsData: {
          ...state?.formsData,
          formIds: updatedFormIds,
          totalForms: totalForms + 1,
        },
        formsMap: updatedFormsMap,
        loaders: {
          ...state.loaders,
          addNewForm: false,
        },
      };
    }

    case formsActions.ADD_NEW_FORM_FAILED: {
      const error = action.payload.error;

      return {
        ...state,
        loaders: {
          ...state.loaders,
          addNewForm: false,
        },
        errors: {
          ...state.errors,
          addNewForm: error,
        },
      };
    }

    case formsActions.DELETE_FORM: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          deleteForm: true,
        },
      };
    }

    case formsActions.DELETE_FORM_SUCCESS: {
      const index: number = action.payload.index;
      const existingFormsMap: IFormsMap = { ...state.formsMap };
      const existingFormIds: string[] = state?.formsData?.formIds || [];
      const formId: string = existingFormIds[index];
      const updatedFormIds: string[] = [
        ...existingFormIds.slice(0, index),
        ...existingFormIds.slice(index + 1),
      ];
      delete existingFormsMap[formId];
      const totalForms = state?.formsData?.totalForms || 0;

      return {
        ...state,
        formsData: {
          ...state?.formsData,
          formIds: updatedFormIds,
          totalForms: totalForms - 1,
        },
        formsMap: { ...existingFormsMap },
        loaders: {
          ...state.loaders,
          deleteForm: false,
        },
      };
    }

    case formsActions.DELETE_FORM_FAILED: {
      const error: string = action.payload.error;

      return {
        ...state,
        loaders: {
          ...state.loaders,
          deleteForm: false,
        },
        errors: {
          ...state.errors,
          deleteForm: error,
        },
      };
    }

    case formsActions.RESET_FORM_RULES: {
      return {
        ...state,
        rulesMap: {},
      };
    }

    case formsActions.DELETE_FORM_RULES: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          deleteFormRules: true,
        },
      };
    }

    case formsActions.DELETE_FORM_RULES_SUCCESS: {
      const formId: string = action.payload.formId;
      const existingFormRuleMap = { ...state.rulesMap };
      delete existingFormRuleMap[formId];
      return {
        ...state,
        rulesMap: existingFormRuleMap,
        loaders: {
          ...state.loaders,
          deleteFormRules: false,
        },
      };
    }

    case formsActions.DELETE_FORM_RULES_FAILURE: {
      const error: string = action.payload.error;
      return {
        ...state,
        loaders: {
          ...state.loaders,
          deleteFormRules: false,
        },
        errors: {
          ...state.errors,
          deleteFormRules: error,
        },
      };
    }

    case formsActions.UPDATE_FORM: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          updateForm: true,
        },
        errors: {
          ...state.errors,
          updateForm: "",
        },
      };
    }

    case formsActions.UPDATE_FORM_SUCCESS: {
      const formData: IFormServer = action.payload.formData;

      const existingFormsMap: IFormsMap = { ...state.formsMap };
      existingFormsMap[formData.id] = formData;

      return {
        ...state,
        loaders: {
          ...state.loaders,
          updateForm: false,
        },
        formsMap: existingFormsMap,
      };
    }

    case formsActions.UPDATE_FORM_FAILED: {
      const error = action.payload.error;

      return {
        ...state,
        loaders: {
          ...state.loaders,
          updateForm: false,
        },
        errors: {
          ...state.errors,
          updateForm: error,
        },
      };
    }

    case formsActions.UPDATE_FORM_RULES: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          updateFormRules: true,
        },
        errors: {
          ...state.errors,
          updateFormRules: "",
        },
      };
    }

    case formsActions.UPDATE_FORM_RULES_SUCCESS: {
      const formRuleData: IAdvancedRulesServer = action.payload.formRuleData;
      const { formId } = formRuleData;
      const existingFormRuleMap = { ...state.rulesMap };
      existingFormRuleMap[formId] = formRuleData;

      return {
        ...state,
        loaders: {
          ...state.loaders,
          updateFormRules: false,
        },
        rulesMap: existingFormRuleMap,
      };
    }

    case formsActions.UPDATE_FORM_RULES_FAILURE: {
      const error = action.payload.error;

      return {
        ...state,
        loaders: {
          ...state.loaders,
          updateFormRules: false,
        },
        errors: {
          ...state.errors,
          updateFormRules: error,
        },
      };
    }

    case formsActions.TRANSFORM_AND_UPDATE_FORM: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          updateForm: true,
        },
        errors: {
          ...state.errors,
          updateForm: "",
        },
      };
    }

    case formsActions.TRANSFORM_AND_UPDATE_FORM_SUCCESS: {
      const formData: IFormServer = action.payload.formData;

      const existingFormsMap: IFormsMap = { ...state.formsMap };
      existingFormsMap[formData.id] = formData;

      return {
        ...state,
        loaders: {
          ...state.loaders,
          updateForm: false,
        },
        formsMap: existingFormsMap,
        // formsData: formData
      };
    }

    case formsActions.TRANSFORM_AND_UPDATE_FORM_FAILED: {
      const error = action.payload.error;

      return {
        ...state,
        loaders: {
          ...state.loaders,
          updateForm: false,
        },
        errors: {
          ...state.errors,
          updateForm: error,
        },
      };
    }

    case formsActions.DUPLICATE_FORM: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          duplicateForm: true,
        },
      };
    }
    case formsActions.DUPLICATE_FORM_SUCCESS: {
      const formData: IFormServer = action.payload.formData;
      const formId: string = formData.id;

      const existingFormsMap: IFormsMap = { ...state.formsMap };
      existingFormsMap[formId] = formData;

      const formIds = [formId, ...state?.formsData?.formIds];
      return {
        ...state,
        loaders: {
          ...state.loaders,
          duplicateForm: false,
        },
        formsMap: existingFormsMap,
        formsData: {
          ...state?.formsData,
          formIds,
          totalForms: state.formsData.totalForms + 1,
        },
      };
    }

    case formsActions.DUPLICATE_FORM_FAILURE: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          duplicateForm: false,
        },
        errors: {
          ...state.errors,
          duplicateForm: action.payload.error,
        },
      };
    }

    case formsActions.CREATE_FORM_RULES: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          createFormRules: true,
        },
        errors: {
          ...state.errors,
          createFormRules: "",
        },
      };
    }

    case formsActions.CREATE_FORM_RULES_SUCCESS: {
      const formRuleData: IAdvancedRulesServer = action.payload.formRuleData;
      const { formId } = formRuleData;
      const existingFormRuleMap = { ...state.rulesMap };
      existingFormRuleMap[formId] = formRuleData;

      return {
        ...state,
        loaders: {
          ...state.loaders,
          createFormRules: false,
        },
        rulesMap: existingFormRuleMap,
      };
    }

    case formsActions.CREATE_FORM_RULES_FAILURE: {
      const error = action.payload.error;

      return {
        ...state,
        loaders: {
          ...state.loaders,
          createFormRules: false,
        },
        errors: {
          ...state.errors,
          createFormRules: error,
        },
      };
    }

    case formsActions.ADD_INFOGRAFIC_ROW_COLUMN: {
      const gridData: IInfographicGridData = action.payload;
      const { rowCount, columnCount } = gridData;
      return {
        ...state,
        infographicMap: {
          ...state.infographicMap,
          activeFormInfographic: {
            ...state.infographicMap.activeFormInfographic,
            rowCount: rowCount,
            columnCount: columnCount,
          },
        },
      };
    }

    case formsActions.FETCH_INFOGRAPHICS_DASHBOARD_DATA_BY_ID: {
      return {
        ...state,
        errors: {
          ...state.errors,
          fetchInfographicsDashBoardDataById: "",
        },
        loaders: {
          ...state.loaders,
          fetchInfographicsDashBoardDataById: true,
        },
      };
    }

    case formsActions.FETCH_INFOGRAPHICS_DASHBOARD_DATA_BY_ID_SUCCESS: {
      const dashBoardData: IInfographicsDashboardDataServer = action.payload;
      const { formId } = dashBoardData;
      const dashboardDataMap = { ...state.dashboardDataMap };
      dashboardDataMap[formId] = dashBoardData;
      return {
        ...state,
        dashboardDataMap,
        loaders: {
          ...state.loaders,
          fetchInfographicsDashBoardDataById: false,
        },
        errors: {
          ...state.errors,
          fetchInfographicsDashBoardDataById: "",
        },
      };
    }

    case formsActions.FETCH_INFOGRAPHICS_DASHBOARD_DATA_BY_ID_FAILURE: {
      const error = action.payload.error;
      return {
        ...state,
        loaders: {
          ...state.loaders,
          fetchInfographicsDashBoardDataById: false,
        },
        errors: {
          ...state.errors,
          fetchInfographicsDashBoardDataById: error,
        },
      };
    }
    case formsActions.UPDATE_INFOGRAPHICS_DASHBOARD_DATA_BY_ID: {
      return {
        ...state,
        errors: {
          ...state.errors,
          updateInfographicsDashBoardDataById: "",
        },
        loaders: {
          ...state.loaders,
          updateInfographicsDashBoardDataById: true,
        },
      };
    }
    case formsActions.UPDATE_INFOGRAPHICS_DASHBOARD_DATA_BY_ID_SUCCESS: {
      const dashBoardData: IInfographicsDashboardDataServer = action.payload;
      const { formId } = dashBoardData;
      const dashboardDataMap = { ...state.dashboardDataMap };
      dashboardDataMap[formId] = dashBoardData;
      return {
        ...state,
        dashboardDataMap,
        loaders: {
          ...state.loaders,
          updateInfographicsDashBoardDataById: false,
        },
      };
    }

    case formsActions.UPDATE_INFOGRAPHICS_DASHBOARD_DATA_BY_ID_FAILURE: {
      const error = action?.payload?.error;
      return {
        ...state,
        loaders: {
          ...state.loaders,
          updateInfographicsDashBoardDataById: false,
        },
        errors: {
          ...state.errors,
          updateInfographicsDashBoardDataById: error,
        },
      };
    }

    case formsActions.UPDATE_WIDGET_DATA: {
      const { formId, widgetData } = action.payload;
      const dashboardDataMap: IDashboardDataMap = {
        ...(state.dashboardDataMap ?? {}),
      };
      const dashboardData: IInfographicsDashboardDataClient =
        dashboardDataMap[formId] ?? {};
      const infographicsWidgetMap = dashboardData?.infographicsWidgetMap ?? {};
      const localId = widgetData?.localId;

      infographicsWidgetMap[localId] = widgetData;
      dashboardDataMap[formId] = { ...dashboardData, infographicsWidgetMap };
      return {
        ...state,
        dashboardDataMap,
      };
    }

    case formsActions.ADD_INFOGRAPHICS_DASHBOARD_DATA_BY_ID: {
      return {
        ...state,
        errors: {
          ...state.errors,
          addInfographicsDashBoardDataById: "",
        },
        loaders: {
          ...state.loaders,
          addInfographicsDashBoardDataById: true,
        },
      };
    }
    case formsActions.ADD_INFOGRAPHICS_DASHBOARD_DATA_BY_ID_SUCCESS: {
      const dashBoardData: IInfographicsDashboardDataServer = action.payload;
      const { formId } = dashBoardData;
      const dashboardDataMap = { ...state.dashboardDataMap };
      dashboardDataMap[formId] = dashBoardData;
      return {
        ...state,
        dashboardDataMap,
        loaders: {
          ...state.loaders,
          addInfographicsDashBoardDataById: false,
        },
      };
    }

    case formsActions.ADD_INFOGRAPHICS_DASHBOARD_DATA_BY_ID_FAILURE: {
      const error = action?.payload?.error;
      return {
        ...state,
        loaders: {
          ...state.loaders,
          addInfographicsDashBoardDataById: false,
        },
        errors: {
          ...state.errors,
          addInfographicsDashBoardDataById: error,
        },
      };
    }
    case formsActions.DELETE_INFOGRAPHICS_DASHBOARD_DATA_BY_FORMID: {
      return {
        ...state,
        errors: {
          ...state.errors,
          deleteInfographicsDashBoardDataByFormId: "",
        },
        loaders: {
          ...state.loaders,
          deleteInfographicsDashBoardDataByFormId: true,
        },
      };
    }

    case formsActions.DELETE_INFOGRAPHICS_DASHBOARD_DATA_BY_FORMID_SUCCESS: {
      const dashboardDataMap = { ...state.dashboardDataMap };
      delete dashboardDataMap[action.payload];
      return {
        ...state,
        dashboardDataMap,
        errors: {
          ...state.errors,
          deleteInfographicsDashBoardDataByFormId: "",
        },
        loaders: {
          ...state.loaders,
          deleteInfographicsDashBoardDataByFormId: false,
          updateInfographicsDashBoardDataById: false,
        },
      };
    }

    case formsActions.DELETE_INFOGRAPHICS_DASHBOARD_DATA_BY_FORMID_FAILURE: {
      return {
        ...state,
        errors: {
          ...state.errors,
          deleteInfographicsDashBoardDataByFormId: "",
        },
        loaders: {
          ...state.loaders,
          deleteInfographicsDashBoardDataByFormId: false,
        },
      };
    }

    case formsActions.ADD_FORM_ANALYTICS: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          addFormAnalytics: true,
        },
      };
    }

    case formsActions.ADD_FORM_ANALYTICS_SUCCESS: {
      return {
        ...state,
        errors: {
          ...state.errors,
          addFormAnalytics: "",
        },
        loaders: {
          ...state.loaders,
          addFormAnalytics: false,
        },
      };
    }

    case formsActions.ADD_FORM_ANALYTICS_FAILURE: {
      return {
        ...state,
        errors: {
          ...state.errors,
          addFormAnalytics: "",
        },
        loaders: {
          ...state.loaders,
          addFormAnalytics: false,
        },
      };
    }

    case formsActions.GET_FORM_ANALYTICS: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          getFormAnalytics: true,
        },
      };
    }

    case formsActions.GET_FORM_ANALYTICS_SUCCESS: {
      const formAnalytics: IActiveInfographicAnalytics = action?.payload;
      return {
        ...state,
        loaders: {
          ...state.loaders,
          getFormAnalytics: true,
        },
        infographicMap: {
          ...state.infographicMap,
          activeInfographicAnalytics: {
            ...state.infographicMap.activeInfographicAnalytics,
            ...formAnalytics,
          },
        },
      };
    }

    case formsActions.GET_FORM_ANALYTICS_FAILURE: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          getFormAnalytics: true,
        },
        errors: {
          ...state.errors,
          getFormAnalytics: "",
        },
      };
    }

    case formsActions.GET_INFOGRAPHIC_DATA_BY_QUERY: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          getInfographicDataByQuery: true,
        },
        errors: {
          ...state.errors,
          getInfographicDataByQuery: "",
        },
      };
    }

    case formsActions.GET_INFOGRAPHIC_DATA_BY_QUERY_SUCCESS: {
      const data: any = action.payload;
      let existingWidgetData =
        state.infographicMap.activeInfographicDataByQuery;
      const activewidgetData: string[] = Object.keys(existingWidgetData);
      if (activewidgetData.includes(Object.keys(data)[0])) {
        existingWidgetData[Object.keys(data)[0]] = data[Object.keys(data)[0]];
      } else {
        existingWidgetData = data;
      }
      return {
        ...state,
        loaders: {
          ...state.loaders,
          getInfographicDataByQuery: false,
        },
        errors: {
          ...state.errors,
          getInfographicDataByQuery: "",
        },
        infographicMap: {
          ...state.infographicMap,
          activeInfographicDataByQuery: {
            ...state.infographicMap.activeInfographicDataByQuery,
            ...existingWidgetData,
          },
        },
      };
    }

    case formsActions.GET_INFOGRAPHIC_DATA_BY_QUERY_FAILURE: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          getInfographicDataByQuery: false,
        },
        errors: {
          ...state.errors,
          getInfographicDataByQuery: "",
        },
      };
    }

    case formsActions.GET_FORM_SUBMISSION_COUNT: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          getSubmissionCount: true,
        },
      };
    }
    case formsActions.GET_FORM_SUBMISSION_COUNT_SUCCESS: {
      const submissionCounts: ISubmissionCount[] =
        action.payload?.submissionCounts;
      const submissionCountMap = { ...state.submissionCountMap };
      submissionCounts.forEach((submissionCount) => {
        submissionCountMap[submissionCount._id] = submissionCount;
      });

      return {
        ...state,
        submissionCountMap: submissionCountMap,
        loaders: {
          ...state.loaders,
          getSubmissionCount: false,
        },
      };
    }

    case formsActions.GET_FORM_SUBMISSION_COUNT_FAILURE: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          getSubmissionCount: false,
        },
        errors: {
          ...state.errors,
          getSubmissionCount: action.payload.error,
        },
      };
    }

    case formsActions.FETCH_OPTIONS_FOR_LOOKUP_FIELD: {
      return {
        ...state,
      };
    }
    case formsActions.FETCH_OPTIONS_FOR_LOOKUP_FIELD_WITH_FILTER: {
      return {
        ...state,
      };
    }

    case formsActions.FETCH_PERMISSION_BY_ID: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          fetchPermissionById: true,
        },
      };
    }

    case formsActions.FETCH_PERMISSION_BY_ID_SUCCESS: {
      const permission: ICustomPermission = action.payload;
      return {
        ...state,
        customPermission: permission,
        loaders: {
          ...state.loaders,
          fetchPermissionById: false,
        },
      };
    }
    case formsActions.FETCH_PERMISSION_BY_ID_FAILED: {
      const error = action.payload.error;

      return {
        ...state,
        loaders: {
          ...state.loaders,
          fetchPermissionById: false,
        },
        errors: {
          ...state.errors,
          fetchPermissionById: error,
        },
      };
    }

    case formsActions.FETCH_WORKFLOW: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          fetchWorkFlow: true,
        },
      };
    }

    case formsActions.FETCH_WORKFLOW_SUCCESS: {
      const workflowList: IWorkflowServer[] = action?.payload;
      const updatedWorkflowMap = { ...state.workflowMap };
      if (workflowList.length > 0) {
        const workflow = workflowList[0];
        const { formId } = workflow;
        updatedWorkflowMap[formId] = workflowList;
      }
      return {
        ...state,
        workflowMap: updatedWorkflowMap,
        loaders: {
          ...state.loaders,
          fetchWorkFlow: false,
        },
      };
    }

    case formsActions.FETCH_WORKFLOW_FAILURE: {
      const error = action.payload.error;
      return {
        ...state,
        loaders: {
          ...state.loaders,
          fetchWorkFlow: false,
        },
        errors: {
          ...state.errors,
          fetchWorkFlow: error,
        },
      };
    }
    case formsActions.FETCH_FORM_BY_IDS_FREE: {
      return {
        ...state,
      };
    }

    default:
      return state;
  }
};
